module.exports = function() {
  return new Worker(__webpack_public_path__ + "67dabe8515176d37a495.worker.js");
};